export default "/images/69142be27ee40ed9a79d687680989c2d.jpg";